// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"379":"dad5d789","510":"a0f66482","728":"bb2c8bb9","789":"7283f2f1","962":"8fc4176a"}[chunkId] + ".chunk.css";
};